import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectTouchpointsPageRoutingModule } from './select-touchpoints-routing.module';

import { SelectTouchpointsPage } from './select-touchpoints.page';
import { TranslateModule } from '@ngx-translate/core';
import { SearchbarComponentModule } from 'src/app/components/searchbar/searchbar.module';
import { HeaderComponentModule } from 'src/app/components/header/header.module';
import { ActionMiniItemComponentModule } from 'src/app/components/action-mini-item/action-mini-item.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    IonicModule,
    SearchbarComponentModule,
    HeaderComponentModule,
    ActionMiniItemComponentModule,
    SelectTouchpointsPageRoutingModule
  ],
  declarations: [SelectTouchpointsPage]
})
export class SelectTouchpointsPageModule {}
